export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-23-0e7c905dbaac87d1fcb314228898810a.jpg";